// @ts-nocheck
export default {
    getterEditSurchargeItemId: ({ editSurchargeItem }) => editSurchargeItem?.id,
    getterSortedGoodsPriceSurchargeInfosList: ({ storeManagementGoodsPriceSurchargeInfosList }) => [
        ...storeManagementGoodsPriceSurchargeInfosList,
    ]?.sort((a, b) => a.orderAmountStart - b.orderAmountStart),
};
